import { setCookie } from '../set-cookie';
import type { AllowedEssentialCookiePrefixName } from './one-trust-categorised-cookies';
import type { setCookieIfConsentIsGiven } from './set-cookie-if-consent-is-given';

export const setEssentialCookie = (
  cookieNameToBeCreated: AllowedEssentialCookiePrefixName,
  cookieValue: string,
  options?: Parameters<typeof setCookieIfConsentIsGiven>[2]
) => {
  setCookie(cookieNameToBeCreated, cookieValue, options);
};
